import { Dropdown } from '../interfaces';

export const DROPDOWN_OPTIONS = (
    callbackAction?: (row: Dropdown) => void,
    callbackAlert?: (row: Dropdown) => void,
    callbackSignOff?: (row: Dropdown) => void
) => [
    // {
    //     title: 'Cambia',
    //     icon: 'roblex-tasa',
    //     routePath: '/home/cambio',
    //     callbackAction: (row: Dropdown) => callbackAction ? callbackAction(row) : null
    // },
    {
        title: 'Perfil',
        icon: 'roblex-usuario2',
        routePath: '/home/perfil',
        callbackAction: (row: Dropdown) => callbackAction ? callbackAction(row) : null
    },
    {
        title: 'Alertas',
        icon: 'roblex-notification',
        callbackAction: (row: Dropdown) => callbackAlert ? callbackAlert(row):null
    },
    // {
    //     title: 'Crédito ganados',
    //     icon: 'roblex-premio',
    //     routePath: '/home/cambio',
    //     callbackAction: (row: Dropdown) => callbackAction ? callbackAction(row) : null
    // },
    // {
    //     title: 'Alerta',
    //     icon: 'roblex-alerta',
    //     routePath: '/home/cambio',
    //     callbackAction: (row: Dropdown) => callbackAction ? callbackAction(row) : null
    // },
    {
        title: 'Cerrar sesión',
        icon: 'roblex-logout',
        callbackAction: (row: Dropdown) => callbackSignOff ? callbackSignOff(row) : null
    },
];
